import { render, staticRenderFns } from "./modalRegister.vue?vue&type=template&id=156c04f8&"
import script from "./modalRegister.vue?vue&type=script&lang=js&"
export * from "./modalRegister.vue?vue&type=script&lang=js&"
import style0 from "./modalRegister.vue?vue&type=style&index=0&id=156c04f8&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports